export interface AutomationVariableReference {
    nodeName: string;
    name: string;
}

export const automationVariableToken = ({nodeName, name}: AutomationVariableReference): string =>
    `{{"${nodeName}".${name}}}`;

export const automationVariableLabel = ({nodeName, name}: AutomationVariableReference): string => `${nodeName} · ${name}`;
